export enum WebsiteProgramListLayout {
    DEFAULT = 'default',
    COMPACT_SINGLE = 'compact-single',
    COMPACT_GROUPED = 'compact-grouped'
}

export const WEBSITE_PROGRAM_LIST_LAYOUTS: WebsiteProgramListLayout[] = [
    WebsiteProgramListLayout.DEFAULT,
    WebsiteProgramListLayout.COMPACT_SINGLE,
    WebsiteProgramListLayout.COMPACT_GROUPED
];
